import React, { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { isGuestStorage, isLoggedInStorage } from '../lib/onboardingStorage';
import { safePostAuthPath } from '../lib/legalConsentGate';
import { useMingo } from '../context/MingoContext';

/**
 * Requires login. Guests see the login modal; after success the same route is re-opened and content renders.
 */
function ProtectedRoute({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { openLoginRequired, refreshAuth } = useMingo();
  const guest = isGuestStorage() || !isLoggedInStorage();
  const opened = useRef(false);
  const path = `${location.pathname}${location.search || ''}`;

  useEffect(() => {
    opened.current = false;
  }, [location.pathname, location.search]);

  useEffect(() => {
    if (!guest) {
      opened.current = false;
      return;
    }
    if (opened.current) return;
    opened.current = true;
    openLoginRequired(() => {
      void refreshAuth();
      navigate(safePostAuthPath(path), { replace: true });
    });
  }, [guest, navigate, openLoginRequired, path, refreshAuth]);

  if (guest) {
    return <div className="mingo-protected-placeholder" aria-hidden="true" />;
  }
  return children;
}

export default ProtectedRoute;
